import { observer } from 'mobx-react';
import { FC } from 'react';
import { CenteredSpinner } from '@servicetitan/standalone-ui';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Loader } from '@servicetitan/web-components';
import { ContentManagementStore } from '../stores/content-management.store';

export const ContentManagementPage: FC = provide({
    singletons: [ContentManagementStore],
})(
    observer(() => {
        const [{ data, basename, source }] = useDependencies(ContentManagementStore);

        return (
            <Loader
                className="w-100"
                data={data}
                src={source}
                basename={basename}
                loadingFallback={<CenteredSpinner />}
            />
        );
    }),
);
